import React, { FC } from 'react';
import Eye from 'ati-ui-react/components/icons/Eye';
import theme from 'theme';
import useMiniCard from 'hooks/useMiniCard';
import { ViewsStyles } from './ViewsStyles';

const Views: FC = () => {
  const {
    data: {
      advert: { viewsCount },
    },
  } = useMiniCard();

  return (
    <ViewsStyles>
      <Eye className="icon" color={theme.colors.limedSpruceLight} width={14} height={8} />
      <span className="text">{viewsCount}</span>
    </ViewsStyles>
  );
};

export default Views;
